"use strict";
module.exports = {
    PASSWORD_EXPIRY_TOKEN_VALID_DURATION_SECONDS: 3600,
    PASSWORD_TOKEN_STATUS: {
        ACTIVE: 'active',
        EXPIRED: 'expired',
        INVALID: 'invalid'
    },
    PASSWORD_TOKEN_INVALID_REASON: {
        EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
        ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
        TOKEN_ALREADY_USED: 'TOKEN_ALREADY_USED',
        TOKEN_EXPIRED: 'TOKEN_EXPIRED'
    }
};
